import { noneProfile } from "assets";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "components/app/dialog/dialog";
import NumberInput from "components/app/function/NumberInput";
import CurrencyInput from "components/app/function/CurrencyInput";
import TextInput from "components/app/function/TextInput";
import ImageUrl from "components/app/image-url/ImageUrl";
import { DialogFooter } from "components/ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectLabel, SelectItem } from "components/ui/select"; // or wherever your library path is
import { Loader, Pyramid, RotateCcw, Save, X } from "lucide-react";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Service } from "utils/services";
import { Switch } from "components/ui/switch";
interface DialogProps {
  userShopEmployeesLeaveCalculation: any;
  editItemCategories: string;
  dailogLeave: boolean;
  filteredData: any;
  userShopShiftGroup: any;
  setIsDailogLeave: (value: boolean) => void;
  setFilteredData: any;
  searchTextInput: string;
  loadingEmployeesCalcaulation: boolean;
  onReset: ({ status }: { status: string }) => void;
}
export default function DailogLeave({ onReset, loadingEmployeesCalcaulation, dailogLeave, setIsDailogLeave, userShopEmployeesLeaveCalculation }: DialogProps) {
  const { showDialogConfirm, showDialogMessage } = appStore();
  const [leaveData, setLeaveData] = useState<any>([]);

  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  // const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 2 }, (_, i) => currentYear + i);
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [hasChange, setHasChange] = useState(false);
  const saveTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleInputChange = (rowIndex: number, field: string, value: string | number) => {
    setHasChange(true);
    const updated = [...leaveData];
    updated[rowIndex] = {
      ...updated[rowIndex],
      [field]: value,
    };
    setLeaveData(updated);
    if (!autoSave) return;

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(() => {
      saveDraftShopEmployeeLeave(updated); // ✅ pass updated data
    }, 15000); // 15 seconds
  };

  const handleFormattedInputChange = (e: React.ChangeEvent<HTMLInputElement>, rowIndex: number, key: string) => {
    const raw = e.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d*$/.test(raw)) return;
    handleInputChange(rowIndex, key, raw);
  };
  // ==========push data =============
  const generateLeaveDatas = () => {
    const data: any[] = [];
    for (const employee of userShopEmployeesLeaveCalculation || []) {
      const entitlementBalance = employee.entitlement_balance || {}; // Assuming `payroll` is a nested object
      const record: any = {
        local_name: employee.local_name,
        picture: employee.picture,
        remark: employee.remark,
        position: entitlementBalance.position || "",
        employee_id: employee.employee_id,
        max_block_leave: entitlementBalance.max_block_leave,
        max_compassionate_leave: entitlementBalance.max_compassionate_leave,
        max_change_day_off_leave: entitlementBalance.max_change_day_off_leave,
        max_marriage_leave: entitlementBalance.max_marriage_leave,
        max_maternity_leave: entitlementBalance.max_maternity_leave,
        max_paternity_leave: entitlementBalance.max_paternity_leave,
        max_special_leave: entitlementBalance.max_special_leave,
        max_suspend_leave: entitlementBalance.max_suspend_leave,
        annual_leave: entitlementBalance.annual_leave,
        sick_leave: entitlementBalance.sick_leave,
        annual_leave_forward: entitlementBalance.annual_leave_forward,
        max_sick_leave: entitlementBalance.max_sick_leave,
        max_annual_leave: entitlementBalance.max_annual_leave,
      };
      data.push(record);
    }
    setLeaveData(data);
    return data;
  };

  const handleReset = () => {
    onReset({ status: "yes" });
    // setLeaveData(generatePayrollDatas);
  };
  useEffect(() => {
    if (userShopEmployeesLeaveCalculation?.length) {
      generateLeaveDatas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userShopEmployeesLeaveCalculation, selectedMonth, selectedYear]);
  // =============submit save draft shop employees===========
  const [loadingSubmitSaveDraftEmployees, setLoadingSubmitSaveDraftEmployees] = useState<boolean>(false);
  const [loadingButtonSave, setLoadingButtonSave] = useState<boolean>(false);
  const saveDraftShopEmployeeLeave = async (leaveDatas: any) => {
    setLoadingSubmitSaveDraftEmployees(true);
    try {
      let url: string = "";
      url = RouteApi.saveDraftShopEmployeeLeave;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        records: leaveDatas,
        year: selectedYear,
      };

      await RequestApi(url, {
        data,
      })
        .then((responses) => {
          if (responses.status === "success") {
            setLoadingSubmitSaveDraftEmployees(false);
            setLoadingButtonSave(false);
          } else {
            showDialogMessage({
              title: responses.status,
              message: responses.msg,
              barrierDismissible: false,
            });
          }
        })
        .catch((err) => {
          setLoadingSubmitSaveDraftEmployees(false);
        });
    } catch (error) {
      setLoadingSubmitSaveDraftEmployees(false);

      AppLog.show({
        message: `[saveDraftShopEmployeePayroll]`,
        status: StatusMsg.error,
        error,
      });
      // setLoadingSubmit(false);
    } finally {
      setLoadingSubmitSaveDraftEmployees(false);
    }
  };

  const inputRefs = useRef<(HTMLInputElement | null)[][]>([]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, row: number, col: number) => {
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        inputRefs.current[row + 1]?.[col]?.focus();
        break;
      case "ArrowUp":
        e.preventDefault();
        inputRefs.current[row - 1]?.[col]?.focus();
        break;
      // case "ArrowRight":
      //   e.preventDefault();
      //   inputRefs.current[row]?.[col + 1]?.focus();
      //   break;
      // case "ArrowLeft":
      //   e.preventDefault();
      //   inputRefs.current[row]?.[col - 1]?.focus();
      //   break;
    }
  };

  const [autoSave, setAutoSave] = useState(() => {
    return localStorage.getItem("autoSave") === "true";
  });

  return (
    <>
      <Dialog open={dailogLeave}>
        <DialogContent
          onOpenAutoFocus={(e) => e.preventDefault()}
          isShowBtnXClose={false}
          className={`${window.innerWidth <= 1500 ? "max-w-[1000px]" : "max-w-[1800px]"}  h-[calc(100vh-80px)] custom-dialog-class flex flex-col  `}
        >
          <DialogHeader>
            <div className="flex items-center justify-between ">
              <div className="flex flex-col gap-2">
                <DialogTitle>Leave Entitlement Balance Setup</DialogTitle>
                <DialogDescription>Configure Individual Leave Entitlement Balances for Each Staff Member.</DialogDescription>
              </div>
              <HoverCardDetail
                title=""
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Auto Save</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>Automatically saves changes 15 seconds after you stop typing.</li>
                    </ul>
                  </>
                }
              >
                <div className="flex gap-3 items-center justify-center  absolute right-[130px] z-40 cursor-pointer ">
                  <p className="text-md  ">Auto Save </p>
                  <Switch
                    checked={autoSave}
                    onCheckedChange={(checked) => {
                      setAutoSave(checked);
                      localStorage.setItem("autoSave", checked.toString());
                    }}
                  />
                </div>
              </HoverCardDetail>
              <HoverCardDetail
                title="Submit"
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Finalize and submit the current data for processing, saving, or review.</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>Ensure all required fields are completed before submission.</li>
                      <li>Once submitted, changes may be locked or require admin approval.</li>
                      <li>Triggers validation, saves data, and notifies relevant stakeholders if applicable.</li>
                      <li>Ideal for finalizing timesheets, form entries, or configuration settings.</li>
                    </ul>
                  </>
                }
              >
                <div
                  onClick={() => {
                    setLoadingButtonSave(true);
                    saveDraftShopEmployeeLeave(leaveData);
                  }}
                  className="absolute p-2 bg-blue-500 text-white flex items-center justify-center right-[90px] top-[22px] z-40 cursor-pointer rounded-full  w-8 h-8  "
                >
                  {loadingSubmitSaveDraftEmployees ? <Loader className="animate-spin" /> : <Save />}
                </div>
              </HoverCardDetail>
            </div>
            <HoverCardDetail
              title="Reset"
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Reset and generate employee timesheets based on the predefined roster.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Use the existing roster to auto-fill employee working hours.</li>
                    <li>Quickly regenerate timesheets for a specific period or shift cycle.</li>
                    <li>Ensure consistency between the roster and recorded timesheets.</li>
                    <li>Useful for handling shift changes, missed entries, or corrections.</li>
                  </ul>
                </>
              }
            >
              <div
                onClick={() => {
                  showDialogConfirm({
                    titileButtonCancel: "No, Cancel",
                    title: "Reset",
                    message: "Do you want to Reset ?",
                    onSubmit() {
                      handleReset();
                    },
                  });
                }}
                className="absolute p-2 bg-red-500 text-white flex items-center justify-center right-[50px] top-[16px] z-40 cursor-pointer rounded-full  w-8 h-8  "
              >
                <RotateCcw />
              </div>
            </HoverCardDetail>
            <div
              onClick={() => {
                setIsDailogLeave(false);
                setLeaveData([]);
                onReset({ status: "No" });
              }}
              className="absolute flex items-center justify-center right-3 top-[16px] z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-8 h-8 border border-gray-300 "
            >
              <X size={18} />
            </div>
          </DialogHeader>
          <div className="flex justify-between items-center mt-5">
            <div className="flex items-center gap-4  w-full ">
              <HoverCardDetail
                title="Select Month & Year"
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Choose a specific month and year to filter, view, or generate time-based records.</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>View timesheets, attendance, or reports for a selected time period.</li>
                      <li>Useful for monthly payroll, scheduling, or performance tracking.</li>
                      <li>Ensures actions apply to the correct billing or reporting cycle.</li>
                    </ul>
                  </>
                }
              >
                <div className="flex">
                  <Select
                    value={selectedYear.toString()}
                    onValueChange={(val) => {
                      setSelectedYear(Number(val));
                      handleReset();
                    }}
                  >
                    <SelectTrigger className="w-[180px] py-3">
                      <SelectValue placeholder="Select Year" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectLabel>Years</SelectLabel>
                        {years.map((year) => (
                          <SelectItem key={year} value={`${year}`}>
                            {year}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </HoverCardDetail>
            </div>
          </div>
          <div
            className={`
             no-scrollbar overflow-x-scroll overflow-y-scroll lg:-w-[1800px] md:-w-[800px]  mt-5 mb-[50px] overflow-hidden `}
          >
            {loadingEmployeesCalcaulation ? (
              <SkeletonMusicLibrariesTable />
            ) : (
              <table className="w-full h-full border-b text-center rounded-md   ">
                <thead className="sticky z-2 top-0 left-0 text-xs text-gray-700  bg-gray-50 dark:bg-[#2c3a52] dark:text-gray-400">
                  <tr className="border dark:bg-[#2c3a52] text-[15px] text-start font-bold">
                    <th rowSpan={2} className="py-4   px-5 border text-center sticky left-0 top-0 bg-gray-200 dark:bg-[#020817] dark:text-white">
                      Staff
                    </th>
                    <th colSpan={3} className="py-4 bg-[#4c7766] px-5 border whitespace-nowrap  text-white ">
                      Entitlement Balance
                    </th>
                    <th colSpan={9} className="py-4 bg-[#1D405C] px-5 border text-white ">
                      Maximum No. of Day Per Request
                    </th>
                    <th rowSpan={2} className="py-4 bg-[#1D405C] px-5 border text-white ">
                      Remark
                    </th>
                  </tr>
                  <tr className=" text-md text-[15px]">
                    <th className="py-4 w-[120px] bg-[#4c7766]  px-5 border text-md   text-white">Carry Forward</th>
                    <th className="py-4 w-[120px] bg-[#4c7766]  px-5 border text-md   text-white"> Annual Leave</th>
                    <th className="py-4 w-[120px]   px-5 border bg-[#4c7766]  text-white ">Sick Leave</th>
                    <th className="py-4 w-[120px] px-2 border bg-[#1D405C]  text-white   ">Compassionate Leave</th>
                    <th className="py-4 w-[120px]  px-5 border  bg-[#1D405C]  text-white  ">Change Day-Off Leave</th>
                    <th className="py-4 w-[120px]  px-5 border bg-[#1D405C]  text-white ">Marriage Leave</th>
                    <th className="py-4 w-[120px] bg-[#1D405C] px-5 border text-md   text-white">Maternity Leave</th>
                    <th className="py-4 w-[120px]  px-5 border bg-[#1D405C]  text-white ">Paternity Leave</th>
                    <th className="py-4 w-[120px]  px-5 border bg-[#1D405C]  text-white ">Special Leave</th>
                    <th className="py-4 w-[120px]  px-5 border bg-[#1D405C]  text-white ">Suspend Leave</th>
                    <th className="py-4 w-[120px]  px-5 border bg-[#1D405C]  text-white ">Annual Leave</th>
                    <th className="py-4 w-[120px]  px-5 border bg-[#1D405C]  text-white ">Sick Leave</th>
                  </tr>
                </thead>
                <tbody>
                  {leaveData?.map((item: any, rowIndex: number) => {
                    return (
                      <tr key={rowIndex} className="text-xs text-gray-700 dark:text-gray-300">
                        <td className="bg-white overflow-hidden dark:bg-[#020817] sticky left-0  z-30 flex items-center justify-center  dark:hover:bg-[#2c3a52] border border-r-0 ">
                          <div className="gap-3 flex items-center  rounded-md p-1  w-[180px] ">
                            <ImageUrl src={!item.picture ? noneProfile : item.picture} className=" h-[45px] w-[45px] rounded-full" alt={item.picture} />
                            <div className="flex flex-col text-start ">
                              {/* <span className="w-full font-medium line-clamp-1 leading-none lg:text-md md:text-sm text-[13px]">{item.local_name.slice(0, 12)...}</span> */}
                              <span className="w-full font-medium line-clamp-1 leading-none lg:text-md md:text-sm text-[13px]">
                                {item.local_name.length > 12 ? `${item.local_name.slice(0, 12)}...` : item.local_name}
                              </span>
                              <span className="text-sm text-muted-foreground line-clamp-1">{item.position.length > 12 ? `${item.position.slice(0, 12)}...` : item.position}</span>
                            </div>
                          </div>
                        </td>

                        {/* Basic Salary */}
                        <td className=" border  m-0 overflow-hidden  ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][0] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 0)} // ✅ Use this!
                            type="text"
                            value={item.annual_leave_forward > 0 ? item.annual_leave_forward : ""}
                            onChange={(e) => handleFormattedInputChange(e, rowIndex, "annual_leave_forward")}
                            className="px-2 w-full border-none focus:border-none outline-none focus:rounded-none h-full rounded-none bg-transparent m-0 text-lg text-end"
                          />
                        </td>

                        <td className="border  m-0 overflow-hidden  ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][1] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 1)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.annual_leave > 0 ? item.annual_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "annual_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden  ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][2] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 2)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.sick_leave > 0 ? item.sick_leave : ""}
                            onChange={(e: any) => handleInputChange(rowIndex, "sick_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden  ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][3] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 3)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            // value={item.no_of_unpaid_day}
                            value={item.max_compassionate_leave > 0 ? item.max_compassionate_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_compassionate_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden  ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][4] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 4)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_change_day_off_leave > 0 ? item.max_change_day_off_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_change_day_off_leave", e.target.value)}
                          />
                        </td>

                        {/* Allowance */}
                        <td className="border  m-0 overflow-hidden     ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][5] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 5)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_marriage_leave > 0 ? item.max_marriage_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_marriage_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden    ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][6] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 6)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_maternity_leave > 0 ? item.max_maternity_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_maternity_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden    ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][7] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 7)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_paternity_leave > 0 ? item.max_paternity_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_paternity_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden    ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][8] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 8)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_special_leave > 0 ? item.max_special_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_special_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden    ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][9] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 9)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_suspend_leave > 0 ? item.max_suspend_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_suspend_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden    ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][10] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 10)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_annual_leave > 0 ? item.max_annual_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_annual_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden    ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][11] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 11)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={item.max_sick_leave > 0 ? item.max_sick_leave : ""}
                            onChange={(e) => handleInputChange(rowIndex, "max_sick_leave", e.target.value)}
                          />
                        </td>
                        <td className="border  m-0 overflow-hidden    ">
                          <input
                            ref={(el) => {
                              if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];
                              inputRefs.current[rowIndex][12] = el;
                            }}
                            onKeyDown={(e) => handleKeyDown(e, rowIndex, 12)} // ✅ Use this!
                            type="text"
                            className="w-full px-2 focus:rounded-none h-full border-none rounded-none bg-transparent  m-0 text-lg text-end"
                            value={!item.remark || item.remark === 0 ? "" : item.remark}
                            onChange={(e) => handleInputChange(rowIndex, "remark", e.target.value)}
                          />
                        </td>
                        {/* Status */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

          <DialogFooter className=" fixed bottom-[10px] right-5">
            {/* <HoverCardDetail
              title="Submit"
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Finalize and submit the current data for processing, saving, or review.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Ensure all required fields are completed before submission.</li>
                    <li>Once submitted, changes may be locked or require admin approval.</li>
                    <li>Triggers validation, saves data, and notifies relevant stakeholders if applicable.</li>
                    <li>Ideal for finalizing timesheets, form entries, or configuration settings.</li>
                  </ul>
                </>
              }
            >
              <button
                onClick={() => {
                
                }}
                className="w-[100px] h-[40px] px-5 mt-6 flex items-center justify-center  bg-[#2563eb] text-white text-lg py-2 rounded-lg"
              >
                {loadingSubmit ? <Loader className="animate-spin" /> : "Submit"}
                Submit
              </button>
            </HoverCardDetail> */}
            {/* </div> */}
          </DialogFooter>
          {/* {loadingSubmit && <div className="flex absolute top-0 left-0 w-full h-full  z-[100] rounded-md"></div>} */}
        </DialogContent>
      </Dialog>
    </>
  );
}
